exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barsideLock,.templateLinkLock, .toggleLock{\n    width: 300px;\n    word-break: \"break-all\";\n    overflow-wrap: \"break-word\";\n    display: \"block\";\n}\n\n.linkLock, .buttonLock, .integrationLock, .actionButtonLock, .checkBoxLock, .anchorLock, .divLock{\n    width: 200px;\n    word-break: \"break-all\";\n    overflow-wrap: \"break-word\";\n    display: \"block\";\n}\n\n.lock{\n    color: #F0AD4E !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/common/rich-text/feature-protection-wrappers/featureProtectionWrapper.styles.css
// module id = 3993
// module chunks = 0